export default __webpack_public_path__ + "a98d7a7cd677b30468054a2f2b620bec.png";